var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 616,
    viewBox: "0 0 998 616",
    width: 998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#27b0d4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.558594 17.0071c0-9.15999 7.821056-16.368124 16.950606-15.62224l461.6748 37.71854c.671.0548 1.345.0555 2.016.0021l478.138-38.06831c7.106-.565762 13.254 4.89835 13.526 12.02161l22.487 589.1702c.282 7.386-5.854 13.413-13.234 12.998l-459.604-25.819h-36.946-42.245l-429.6933 18.201c-7.12717.302-13.070106-5.394-13.070106-12.528z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2003 43.9937c-.0587-6.9664 5.5724-12.6451 12.539-12.6451h958.6607c7.118 0 12.808 5.9176 12.53 13.0298l-20.855 532.9796c-.264 6.729-5.796 12.049-12.53 12.049h-435.196-42.718-42.171-413.2297c-6.8841 0-12.481-5.55-12.539-12.434z",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoHighlight);
export default __webpack_public_path__ + "static/media/VideoHighlight.c757c40733f7e689fc9f298cee2afcec.svg";
export { ForwardRef as ReactComponent };